<template>
  <TemplateNodeRenderer
    v-for="(node, index) in renderTree"
    :key="node.id || `${node.component}-${index}`"
    :node="node"
    :selected-id="selectedId"
    :selection-version="selectionVersion"
    :disable-interaction="disableInteraction"
    :wrap-node="wrapNode"
    @select="handleSelect"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { buildRenderTree } from '~/utils/templateSdk'
import type { TemplateJson } from '~/utils/templateSdk'

const props = defineProps<{
  template: TemplateJson
  selectedId?: string | null
  selectionVersion?: number
  disableInteraction?: boolean
  wrapNode?: boolean
}>()

const emit = defineEmits<{
  (event: 'select', nodeId: string, node: unknown): void
}>()

const renderTree = computed(() => buildRenderTree(props.template))

const wrapNode = computed(() => props.wrapNode !== false)

const handleSelect = (node: unknown) => {
  const id = (node as { id?: string })?.id
  if (id) emit('select', id, node)
}

</script>
